/*
#*===================================================================
#*
#* Licensed Materials - Property of GameTimeFootage Inc.
#*
#* Copyright NextPro 2018. All Rights Reserved.
#*
#*===================================================================
*/
import * as fromGetProFeedback from 'app/library/store/actions/get-library-pro-feedback.action';

export interface GetLibraryProFeedbackState {
  items: any[];
  errorMessage: string | null;
  success: boolean;
  loading: boolean;
}

export const defaultLibraryProFeedback: GetLibraryProFeedbackState = {
  items: [],
  errorMessage: null,
  success: false,
  loading: false,
};

export const initialState = defaultLibraryProFeedback;

export function reducer(
  state = initialState,
  action: fromGetProFeedback.GetLibraryProFeedbackAction
): GetLibraryProFeedbackState {
  switch (action.type) {
    case fromGetProFeedback.GET_LIBRARY_PRO_FEEDBACK: {
      return {
        ...state,
        items: [],
        errorMessage: null,
        loading: true,
        success: false,
      };
    }

    case fromGetProFeedback.GET_LIBRARY_PRO_FEEDBACK_FAIL: {
      return {
        ...state,
        items: [],
        errorMessage: action.payload,
        loading: false,
        success: false,
      };
    }

    case fromGetProFeedback.GET_LIBRARY_PRO_FEEDBACK_SUCCESS: {
      return {
        ...state,
        items: action.payload,
        errorMessage: null,
        loading: false,
        success: true,
      };
    }

    default:
      return { ...state };
  }
}

export const getProFeedbackData = (state: GetLibraryProFeedbackState) => state.items;
export const getProFeedbackErrorMessage = (state: GetLibraryProFeedbackState) => state.errorMessage;
export const getProFeedbackLoading = (state: GetLibraryProFeedbackState) => state.loading;
export const getProFeedbackSuccess = (state: GetLibraryProFeedbackState) => state.success;
